module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-36366fa5.png";